import { useState } from 'react';
import { Menu, X } from 'lucide-react';

const navLinks = [
  { label: 'Services', href: '#services' },
  { label: 'Pricing', href: '#pricing' },
  { label: 'Case Studies', href: '#case-studies' },
  { label: 'Testimonials', href: '#testimonials' },
  { label: 'FAQ', href: '#faq' },
];

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-[#F9F7F2]/85 backdrop-blur-xl border-b border-[#1B3F33]/10" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <a href="#" className="font-heading text-2xl font-semibold text-[#1B3F33]" data-testid="logo">
          Emplozera<span className="text-[#8C6330]"> Studio</span>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="text-sm font-medium text-[#4A5568] hover:text-[#1B3F33] transition-colors duration-300"
              data-testid={`nav-${link.label.toLowerCase().replace(/\s/g, '-')}`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          <a
            href="#consultation"
            className="bg-[#1B3F33] text-white hover:bg-[#265E4A] rounded-full px-6 py-2.5 text-sm font-medium transition-all duration-300"
            data-testid="nav-cta"
          >
            Book a Session
          </a>
        </div>

        <button
          className="lg:hidden text-[#1B3F33]"
          onClick={() => setIsOpen(!isOpen)}
          data-testid="mobile-menu-toggle"
        >
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {isOpen && (
        <div className="lg:hidden mobile-menu bg-[#F9F7F2] border-t border-[#D6CEBF] px-6 py-4" data-testid="mobile-menu">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="block py-3 text-[#4A5568] hover:text-[#1B3F33] font-medium transition-colors"
              onClick={() => setIsOpen(false)}
            >
              {link.label}
            </a>
          ))}
          <a
            href="#consultation"
            className="block mt-4 text-center bg-[#1B3F33] text-white rounded-full px-6 py-2.5 text-sm font-medium"
            onClick={() => setIsOpen(false)}
            data-testid="mobile-cta"
          >
            Book a Session
          </a>
        </div>
      )}
    </header>
  );
};

export default Navbar;
